// Text for these lives in src/locales/*.json (see pages.about.why.<key>).

export const WHY_US = [
  { key: 'identity', color: 'var(--color-primary)', icon: '🐾' },
  { key: 'ecosystem', color: 'var(--color-green)', icon: '🔗' },
  { key: 'community', color: 'var(--color-error)', icon: '📍' },
  { key: 'trust', color: '#f5a623', icon: '🛡️' },
];
